export type TenantMembershipRole = 'guest' | 'member' | 'champion' | 'admin';

export const ALL_TENANT_MEMBERSHIP_ROLES: TenantMembershipRole[] = ['guest', 'member', 'champion', 'admin'];
export const NON_GUEST_TENANT_MEMBERSHIP_ROLES: TenantMembershipRole[] = ['member', 'champion', 'admin'];
export const CHAMPION_TENANT_MEMBERSHIP_ROLES: TenantMembershipRole[] = ['champion', 'admin'];
export const ADMIN_TENANT_MEMBERSHIP_ROLES: TenantMembershipRole[] = ['admin'];

/** Return whether ``role`` administers its tenant. */
export function isTenantAdminRole(role: TenantMembershipRole | null | undefined): boolean {
  return !!role && ADMIN_TENANT_MEMBERSHIP_ROLES.includes(role);
}
